<ui-page-container size="medium">
  <mat-card>
    <mat-card-title>
      {{ (entityId ? 'Modifica persona: ' + personName : 'Nuova persona') | translate }}
    </mat-card-title>
    <mat-card-content>
      <form
        *ngIf="entityForm"
        [formGroup]="entityForm"
        (ngSubmit)="dispatchAction(entityForm)">
        <mat-tab-group animationDuration="0ms">
          <mat-tab [label]="'Generali' | translate">
            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                name="nome"
                matInput
                formControlName="nome"
                [placeholder]="'Nome' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                name="cognome"
                matInput
                formControlName="cognome"
                [placeholder]="'Cognome' | translate">
            </mat-form-field>

            <app-input-vocabulary-autocomplete
              formControlName="tipo"
              [vocabularyName]="'V_Persona_tipo'"
              [placeholder]="'Tipo'">
            </app-input-vocabulary-autocomplete>

            <app-input-vocabulary-autocomplete
              formControlName="categoria"
              [vocabularyName]="'V_Persona_categoria'"
              [placeholder]="'Categoria'">
            </app-input-vocabulary-autocomplete>

            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                name="ragioneSociale"
                matInput
                formControlName="ragioneSociale"
                [placeholder]="'Ragione Sociale' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                name="codiceFiscale"
                matInput
                formControlName="codiceFiscale"
                [placeholder]="'Codice Fiscale' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                name="partitaIva"
                matInput
                formControlName="partitaIva"
                [placeholder]="'Partita IVA' | translate">
            </mat-form-field>

            <h3>{{ 'Tag' | translate }}</h3>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['Persona']">
              <p>
                {{ 'Inserisci uno o più tag.' | translate }}
              </p>
              <mat-form-field
                class="input-expanse"
                appearance="fill">
                <mat-label>{{ 'Tag' | translate }}</mat-label>
                <mat-chip-grid #chipList>
                  <mat-chip-row
                    *ngFor="let tag of entityForm?.get('tag').value; let i = index"
                    [removable]="true"
                    (removed)="removeTagHandler(entityForm?.get('tag'), i)">
                    {{ tag }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                  <input
                    #inputTag
                    placeholder="Nuovo tag"
                    [matChipInputAddOnBlur]="true"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addTagHandler(entityForm?.get('tag'), $event, inputTag)">
                </mat-chip-grid>
              </mat-form-field>
            </ng-container>

            <ng-container *roleVisibility="['create', 'update']; classNames: ['Persona']; behaviour: 'show'">
              <p *ngIf="(entityForm?.get('tag')?.controls || []).length > 0">{{ 'Tag presenti' | translate }}</p>
              <p *ngIf="(entityForm?.get('tag')?.controls || []).length === 0">{{ 'Nessun tag presente' | translate }}</p>
              <mat-chip-listbox>
                <mat-chip *ngFor="let t of entityForm?.get('tag')?.controls || []">{{ t.value }}</mat-chip>
              </mat-chip-listbox>
            </ng-container>
          </mat-tab>
          <mat-tab [label]="'Contatti' | translate">
            <h3>
              {{ 'Gestisci uno più contatti per la seguente persona' | translate }}
            </h3>
            <app-person-contact-form
              [classNames]="['Person']"
              [form]="entityForm?.get('contatti')">
            </app-person-contact-form>
          </mat-tab>
        </mat-tab-group>

        <div class="person-actions">
          <button
            mat-raised-button
            color="primary"
            type="submit">
            {{ (entityId ? 'Modifica' : 'Crea') | translate }}
          </button>
        </div>
      </form>

    </mat-card-content>
  </mat-card>
</ui-page-container>
